/**
 * Hiusextra: alle 990 px:n leveydellä header on aina mobiiliheader (hampurilaisvalikko).
 *
 * Horizon vaihtaa hampurilaisvalikkoon vain, kun valikko ei mahdu (tai laite on kosketusnäyttö),
 * joten esim. 900 px:n leveydellä näkyisi muuten desktop-valikko. Kun Horizon asettaa
 * data-menu-style="menu" alle 990 px:n leveydellä, se vaihdetaan "drawer"-tilaan.
 */
(function () {
  const header = document.getElementById('header-component');
  if (!header) return;

  const mobile = window.matchMedia('(max-width: 989px)');

  function enforce() {
    if (mobile.matches && header.dataset.menuStyle === 'menu') {
      header.dataset.menuStyle = 'drawer';
    }
  }

  new MutationObserver(enforce).observe(header, { attributes: true, attributeFilter: ['data-menu-style'] });
  mobile.addEventListener('change', enforce);
  enforce();
})();
